import { useState } from "react";
import GridTable from "../../components/GridTable";

const EmployeePerformance = () => {
  const [rows] = useState([]);

  const columns = [
    {
      field: "employeeName",
      headerName: "Employee Name",
      width: 100,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "reviewedBy",
      headerName: "Reviewed By",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "performance",
      headerName: "Performance",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "comments",
      headerName: "Comments",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "templateType",
      headerName: "Template Type",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "updatedDate",
      headerName: "Updated Date",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
  ];

  const onClickFilter = () => {
    // TODO: Implement filter functionality
  };

  const onClickAction = (actionType, row, id) => {
    switch (actionType) {
      case "EDIT":
        // TODO: Implement edit functionality
        console.log("Edit action for row:", row);
        break;
      case "DELETE":
        // TODO: Implement delete functionality
        console.log("Delete action for id:", id);
        break;
      case "VIEW":
        // TODO: Implement view functionality
        console.log("View action for row:", row);
        break;
      default:
        console.log("Unknown action type:", actionType);
    }
  };

  return (
    <div className="mb-5">
      <GridTable
        onClickAction={onClickAction}
        actions={["VIEW"]}
        rowData={rows}
        columnData={columns}
        onClickFilter={onClickFilter}
        hideSearchBar={true}
      />
    </div>
  );
};

export default EmployeePerformance;
